import { useMemo, VFC } from 'react';
import { formatPressure } from '@packages/utils';
import HorizontalReportPanel from '../HorizontalReportPanel';

type ReportDataPressureProps = {
  min: number | undefined;
  avg: number | undefined;
  max: number | undefined;
};

const ReportDataPressure: VFC<ReportDataPressureProps> = ({ min, avg, max }) => {
  const columns = useMemo(() => {
    return [
      {
        name: 'Minimum',
        value: formatPressure(min),
      },
      {
        name: 'Average',
        value: formatPressure(avg),
      },
      {
        name: 'Maximum',
        value: formatPressure(max),
      },
    ];
  }, [min, avg, max]);

  return <HorizontalReportPanel columns={columns} />;
};

export default ReportDataPressure;
